import React from 'react'
import styles from './CheckBoxV3.module.css'

function CheckBoxV3({id, value, setValue, label }) {
    return (
        <div className={styles.container}>
            <div className={styles.round}>
                <input id={id} type="checkbox" checked={value} onChange={(e) => { setValue(e.target.checked) }} />
                <label for={id}></label>
                {label ? (
                    <span className="w-[100%]">{label}</span>
                ) : null}
            </div>
        </div>
    )
}

export default CheckBoxV3